var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            { staticClass: "flexRowCenter" },
            [
              _c("b", { staticClass: "flex2" }, [
                _vm._v("LA Sex Trafficking Tool")
              ]),
              _vm._v(" "),
              _vm.isAllowedToCreateOrEditPerson
                ? _c(
                    "router-link",
                    { attrs: { to: _vm.addScreeningLink } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "headerBtn",
                          attrs: { variant: "outline-primary" }
                        },
                        [_vm._v("Add Screening")]
                      )
                    ],
                    1
                  )
                : _c(
                    "b-button",
                    {
                      staticClass: "headerBtn",
                      attrs: { disabled: "", variant: "outline-primary" }
                    },
                    [_vm._v("Add Screening")]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm.screenings.length > 0
            ? _c(
                "div",
                _vm._l(_vm.screenings, function(s) {
                  return _c(
                    "b-list-group",
                    { key: s.id, attrs: { flush: "" } },
                    [
                      _c(
                        "b-list-group-item",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to:
                                  "/traffickingScreening/" +
                                  s.id +
                                  "/view/conclusion"
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm
                                      .$moment(s.createdAt)
                                      .format("MM/DD/YYYY")
                                  ) +
                                  " " +
                                  _vm._s(s.id) +
                                  "\n                            "
                              ),
                              s.conclusion ===
                              _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL1
                                ? _c("img", {
                                    staticClass: "s-icon",
                                    attrs: {
                                      src: "/static/img/ConcernPossible.png",
                                      height: "21",
                                      width: "21"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              s.conclusion ===
                              _vm.TRAFFICKING_SCREENING_CONCLUSION_ENUM.LEVEL2
                                ? _c("img", {
                                    staticClass: "s-icon",
                                    attrs: {
                                      src: "/static/img/ConcernDanger.png",
                                      height: "21",
                                      width: "21"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sIsShared(s)
                                ? _c("img", {
                                    attrs: {
                                      src: "/static/img/shareYes.png",
                                      height: "21",
                                      width: "21"
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.screenings.length > 0 && _vm.oldScreenings.length > 0
            ? _c("div", { style: { borderBottom: "1px solid #00000020" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.oldScreenings.length > 0
            ? _c(
                "div",
                _vm._l(_vm.oldScreenings, function(screening) {
                  return _c(
                    "b-list-group",
                    { key: screening._id, attrs: { flush: "" } },
                    [
                      _c(
                        "b-list-group-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.setViewOldScreening(screening)
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "concl_",
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm
                                      .$moment(screening.createdAt)
                                      .format("MM/DD/YYYY")
                                  ) +
                                  "\n                            " +
                                  _vm._s(screening.id) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          screening.conclusion ==
                          _vm.OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM.CONCERN
                            ? _c("img", {
                                staticClass: "s-icon",
                                attrs: {
                                  src: "/static/img/ConcernPossible.png",
                                  height: "21",
                                  width: "21"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          screening.conclusion ==
                          _vm.OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM
                            .INDICATED
                            ? _c("img", {
                                staticClass: "s-icon",
                                attrs: {
                                  src: "/static/img/ConcernDanger.png",
                                  height: "21",
                                  width: "21"
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.screenings.length > 0 || _vm.oldScreenings.length > 0
            ? _c(
                "div",
                [
                  _vm.isAllowedToCreateOrEditPerson
                    ? _c(
                        "router-link",
                        {
                          attrs: {
                            to: "/person/" + _vm.personId + "/edit?tabIndex=1"
                          }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-3",
                              staticStyle: { "margin-left": "1.25rem" },
                              attrs: {
                                type: "button",
                                variant: "danger",
                                size: "md"
                              }
                            },
                            [
                              _c("span", { staticClass: "button-text" }, [
                                _vm._v("Update Victim Status")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.oldScreenings.length === 0 && _vm.screenings.length === 0
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [
                          _vm._v(
                            "\n                            No Sex Trafficking Screenings\n                        "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showAddOldTsModal
        ? _c("AddOldTraffickingScreeningModal", {
            attrs: { personId: _vm.person._id },
            on: { close: _vm.closeAddOldTsModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showViewOldTsModal
        ? _c("ViewOldTraffickingScreeningModal", {
            attrs: {
              personId: _vm.person._id,
              screening: _vm.viewOldScreening
            },
            on: { close: _vm.closeViewOldTsModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9a4ff82", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9a4ff82","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TraffickingScreening/TraffickingScreeningCard.vue
// module id = 1637
// module chunks = 0